/**
 * Normalize a date value to ISO date string (YYYY-MM-DD) for consistent key lookups.
 */
export function normalizeDate(value) {
  const normalized = (value || '').toString().trim();
  if (!normalized) return '';
  const parsed = new Date(normalized);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toISOString().slice(0, 10);
  }
  return normalized;
}

/**
 * Build normalized map of date key -> times from raw timesByDate object.
 */
export function normalizedTimesByDate(timesByDateRaw, normalizeDateFn = normalizeDate) {
  const out = {};
  Object.entries(timesByDateRaw || {}).forEach(([key, value]) => {
    out[normalizeDateFn(key)] = value || [];
  });
  return out;
}

export function slotsLabel(count) {
  const n = Number(count) || 0;
  return n === 1 ? 'slot' : 'slots';
}
